module.exports = __webpack_public_path__ + "static/img/rm_brand_img_yumeigui_top.9579ace.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/rm_brand_img/rm_brand_img_yumeigui_top.png
// module id = bs7T
// module chunks = 1